import React, { useEffect, useState } from 'react';

import { Text } from 'components/ui';

import { wrapFunctionalComponent } from 'utils/framework';
import isFunction from 'utils/functions/isFunction';

const RESEND_CODE_IN_SECONDS = 30;

function OtpTimer({ localization = {}, onTimeoutCallback, resetTimer = false }) {
    const [seconds, setSeconds] = useState(RESEND_CODE_IN_SECONDS);

    // Run the interval
    useEffect(() => {
        // Exit early if the seconds is already finished
        if (seconds === 0) {
            isFunction(onTimeoutCallback) && onTimeoutCallback();

            return;
        }

        const intervalId = setInterval(() => {
            setSeconds(prevSeconds => prevSeconds - 1);
        }, 1000);

        // Clear the interval when the component unmounts or seconds reaches 0
        // eslint-disable-next-line consistent-return
        return () => clearInterval(intervalId);
    }, [seconds, onTimeoutCallback]); // Re-run the effect if seconds changes

    // Reset timer
    useEffect(() => {
        if (resetTimer) {
            setSeconds(RESEND_CODE_IN_SECONDS);
        }
    }, [resetTimer]);

    return (
        <Text
            fontWeight='bold'
            children={`${seconds} ${localization.seconds}`}
        />
    );
}

export default wrapFunctionalComponent(OtpTimer, 'OtpTimer');
